import { useEffect, useState } from 'react';
import CloseButton from '@/shared/components/CloseButton';
import { useLanguage } from '@shared/contexts/LanguageContext';

function isLineInAppBrowser() {
  if (typeof navigator === 'undefined') return false;
  return /\bLine\//i.test(navigator.userAgent || '');
}

function shouldSkipNotice() {
  if (typeof window === 'undefined') return true;
  const v = new URLSearchParams(window.location.search).get('openExternalBrowser');
  return v === '1' || v === 'true';
}

function buildUrlWithOpenExternal() {
  const url = new URL(window.location.href);
  url.searchParams.set('openExternalBrowser', '1');
  return url.toString();
}

export default function LineBrowserNoticeDialog() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isLineInAppBrowser() || shouldSkipNotice()) return;
    setOpen(true);
  }, []);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/45 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="line-browser-notice-title"
    >
      <div className="relative w-full max-w-[min(100%,20rem)] rounded-2xl bg-[#FAF7F3] px-5 pb-6 pt-14 shadow-xl ring-1 ring-black/5">
        <CloseButton type="button" aria-label={t('line-browser.closeAria')} onClick={() => setOpen(false)} />
        <p
          id="line-browser-notice-title"
          className="text-center text-lg leading-relaxed text-[--color-text-main]"
        >
          {t('line-browser.notice')}
        </p>
        <button
          type="button"
          className="w-full h-[44px] mt-3 bg-[#BC313D] rounded-full text-white text-[18px] font-medium flex items-center justify-center hover:opacity-90 active:scale-[0.98] transition-all disabled:opacity-70 cursor-pointer"
          style={{ fontFamily: 'Noto Sans TC' }}
          onClick={() => {
            window.location.href = buildUrlWithOpenExternal();
          }}
        >
          {t('line-browser.openInBrowser')}
        </button>
      </div>
    </div>
  );
}
